import { render, staticRenderFns } from "./LoadMaterialScanIndex.vue?vue&type=template&id=2230e902&"
import script from "./LoadMaterialScanIndex.vue?vue&type=script&lang=js&"
export * from "./LoadMaterialScanIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports